import React from 'react';
import { RouteComponentProps, withRouter, useLocation } from 'react-router';

import {
  IonContent,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  IonListHeader,
  IonMenu,
  IonMenuToggle,
  IonToggle,
} from '@ionic/react';
import {
  calendarOutline,
  moonOutline,
  informationCircleOutline,
  logIn,
  logOut,
  peopleOutline,
  person,
  personAdd,
  storefrontOutline
} from 'ionicons/icons';

import { connect } from '../data/connect';
import { setDarkMode } from '../data/user/user.actions';

import './Menu.css';

const routes = {
  appPages: [
    { title: '入　庫', path: '/tabs/store', icon: storefrontOutline },
    { title: '出　庫', path: '/tabs/shipment', icon: calendarOutline },
    { title: '検　品', path: '/tabs/inspection', icon: informationCircleOutline },
    { title: '出　荷', path: '/tabs/shipping', icon: peopleOutline },
    { title: '仮置き倉庫', path: '/tabs/kostore', icon: storefrontOutline},
  ],
  loggedInPages: [
    { title: 'アカウント', path: '/account', icon: person },
    { title: 'サインアウト', path: '/logout', icon: logOut },
  ],
  loggedOutPages: [
    { title: '登　録', path: '/signup', icon: personAdd },
    { title: 'ログイン', path: '/login', icon: logIn },
  ],
};

interface Pages {
  title: string;
  path: string;
  icon: string;
  routerDirection?: string;
}
interface StateProps {
  darkMode: boolean;
  isAuthenticated: boolean;
  menuEnabled: boolean;
}

interface DispatchProps {
  setDarkMode: typeof setDarkMode;
}

interface MenuProps extends RouteComponentProps, StateProps, DispatchProps {}

const Menu: React.FC<MenuProps> = ({
  darkMode,
  history,
  isAuthenticated,
  setDarkMode,
  menuEnabled,
}) => {
  const location = useLocation();

  function renderlistItems(list: Pages[]) {
    return list
      .filter((route) => !!route.path)
      .map((p) => (
        <IonMenuToggle key={p.title} auto-hide="false">
          <IonItem
            detail={false}
            routerLink={p.path}
            routerDirection="none"
            className={
              location.pathname.startsWith(p.path) ? 'selected' : undefined
            }
          >
            <IonIcon slot="start" icon={p.icon} />
            <IonLabel>{p.title}</IonLabel>
          </IonItem>
        </IonMenuToggle>
      ));
  }

  return (
    <IonMenu type="overlay" disabled={!menuEnabled} contentId="main">
      <IonContent forceOverscroll={false}>
        { isAuthenticated && 
          <IonList lines="none">
            <IonListHeader>在庫管理</IonListHeader>
            {renderlistItems(routes.appPages)}
          </IonList>
        }
        <IonList lines="none">
          <IonListHeader>アカウント管理</IonListHeader>
          { isAuthenticated
            ? renderlistItems(routes.loggedInPages)
            : renderlistItems(routes.loggedOutPages)}
          <IonItem>
            <IonIcon
              slot="start"
              icon={moonOutline}
              aria-hidden="true"
            ></IonIcon>
            <IonToggle
              checked={darkMode}
              onClick={() => setDarkMode(!darkMode)}
            >
              ダークモード
            </IonToggle>
          </IonItem>
        </IonList>
      </IonContent>
    </IonMenu>
  );
};

export default connect<{}, StateProps, {}>({
  mapStateToProps: (state) => ({
    darkMode: state.user.darkMode,
    isAuthenticated: state.user.isLoggedin,
    menuEnabled: state.data.menuEnabled,
  }),
  mapDispatchToProps: {
    setDarkMode,
  },
  component: withRouter(Menu),
});
